// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC-1N0xOgROyrlDOIfMk3f87WxZfrIXeog",
  authDomain: "quote-installation.firebaseapp.com",
  projectId: "quote-installation",
  storageBucket: "quote-installation.firebasestorage.app",
  messagingSenderId: "590755173429",
  appId: "1:590755173429:web:9e50e488cb474c662d8d7c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;